export default __webpack_public_path__ + "static/plan-enterprise2-0f61af84948a5e8aab28ff151166d99f.svg";